import qs from "qs";
import qsUrl from "../libs/qs-url";

function setLocation(href) {
    if (href !== location.href) {
        location.href = href;
    }
}

export function addParams(paramsObj, options) {
    setLocation(qsUrl.addParams(paramsObj, options));
}

export function removeParams(fields, options) {
    setLocation(qsUrl.removeParams(fields, options));
}

export function setParams(paramsObj) {
    paramsObj = paramsObj || {};
    let removeFields = [];
    for (let field of Object.getOwnPropertyNames(paramsObj)) {
        if (!paramsObj[field] && paramsObj[field] !== 0) {
            removeFields.push(field);
            delete paramsObj[field];
        }
    }

    if (removeFields.length > 0) {
        removeParams(removeFields);
    }
    if (Object.getOwnPropertyNames(paramsObj).length > 0) {
        addParams(paramsObj);
    }
}

export function getParams() {
    return qsUrl.parseUrl().params || {};
}

export function getParam(field) {
    return getParams()[field];
}

export function parse() {
    return qsUrl.parseUrl();
}

export function queryToParams(paramsObj) {
    paramsObj = paramsObj || {};
    if (Object.getOwnPropertyNames(paramsObj).length > 0) {
        let urlInfo = parse();
        let params = Object.assign({}, urlInfo.params, paramsObj);
        qsUrl.setBaseUrl(urlInfo.url + "#/?" + qs.stringify(params));
    }
}
